import { useEffect, useState } from 'react';
import { useVideoContext } from '../main';
export default function useHostDataTrack() {
    const { room } = useVideoContext();
    let hostDataPublication;
    // Identify hostdatatrack in list of participants
    if (room.participants) {
        room.participants.forEach(p => {
            // We want the data track the host's video participant (not phone)
            if (p.identity.startsWith('host.video')) {
                hostDataPublication = p.dataTracks.values().next().value;
            }
        });
    }
    const [track, setTrack] = useState(hostDataPublication && hostDataPublication.track);
    useEffect(() => {
        // Reset the track when the 'publication' variable changes.
        setTrack(hostDataPublication && hostDataPublication.track);
        let cb;
        if (hostDataPublication) {
            const removeTrack = () => setTrack(null);
            hostDataPublication.on('subscribed', setTrack);
            hostDataPublication.on('unsubscribed', removeTrack);
            cb = () => {
                hostDataPublication === null || hostDataPublication === void 0 ? void 0 : hostDataPublication.off('subscribed', setTrack);
                hostDataPublication === null || hostDataPublication === void 0 ? void 0 : hostDataPublication.off('unsubscribed', removeTrack);
            };
        }
        return cb;
    }, [hostDataPublication]);
    return track;
}
//# sourceMappingURL=useHostDataTrack.js.map